import React from 'react';

export const Pill = ({ label, onClose }) => (
  <div className="flex items-center bg-gray-700 text-white px-3 py-1 rounded-full mr-2 mb-2">
    <span>{label}</span>
    {onClose && (
      <button onClick={onClose} className="ml-2 text-xl leading-none">
        &times;
      </button>
    )}
  </div>
);
